import { useSelector } from "react-redux";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Layout from "../components/Layout/Layout";
import { useAxiosInterceptor } from "../hooks";
import { LandingPage, Login } from "../pages";
import Accounts from "../pages/Account/Accounts";
import AddAccount from "../pages/Account/AddAccount";
import DetailsAccount from "../pages/Account/DetailsAccount";
import ActivityAdd from "../pages/Activities/ActivityAdd";
import DetailsActivity from "../pages/Activities/DetailsActivity";
import Admin from "../pages/Admin";
import AdminAudit from "../pages/Admin/Audit";
import EmailLogsPage from "../pages/EmailLogs/EmailLogsPage";
import Homepage from "../pages/Homepage";
import LicensesPage from "../pages/Licenses/Licenses";
import DetailsProcedure from "../pages/Procedures/DetailsProcedure";
import ProcedureAdd from "../pages/Procedures/ProcedureAdd";
import TenderProcedures from "../pages/Procedures/TenderProcedures";
import { DetailsProject } from "../pages/Projects";
import ProjectAddWrapper from "../pages/Projects/ProjectAddWrapper";
import Projects from "../pages/Projects/Projects";
import StageAnswers from "../pages/Stages/StageAnswers";
import StageAwardReports from "../pages/Stages/StageAwardReports";
import StageComplaints from "../pages/Stages/StageComplaints";
import StagePreliminaryReports from "../pages/Stages/StagePreliminaryReports";
import StageProposals from "../pages/Stages/StageProposals";
import StageQuestions from "../pages/Stages/StageQuestions";
import StageReport from "../pages/Stages/StageReport";
import StageTerms from "../pages/Stages/StageTerms";
import { Users } from "../pages/Users";
import ManageUser from "../pages/Users/ManageUser";
import UserProfile from "../pages/Users/UserProfile";
import { SessionStore } from "../types/store/SessionStore";
import { StoreInterfaces } from "../types/store/StoreInterfaces";

const PrivateRoutes = () => {
  const accessToken: SessionStore["accessToken"] = useSelector(
    (state: StoreInterfaces) => state.session.accessToken
  );
  return accessToken ? (
    <Layout>
      <Outlet />
    </Layout>
  ) : (
    <Navigate to="/" />
  );
};

const PublicRoutes = () => {
  return <Outlet />;
};

const Router = () => {
  useAxiosInterceptor();

  return (
    <Routes>
      <Route element={<PrivateRoutes />}>
        <Route path="/home" element={<Homepage />} />
        <Route path="/profile" element={<UserProfile />} />

        {/* Admin */}
        <Route path="/admin" element={<Admin />}>
          <Route path="audit" element={<AdminAudit />} />
          <Route path="email-logs" element={<EmailLogsPage />} />
          <Route path="users" element={<Users />} />
          <Route path="accounts/:accountId/users/:userId" element={<ManageUser />} />
        </Route>

        {/* Global Views */}
        <Route path="/projects/list" element={<Projects />} />
        <Route path="/procedures/tender" element={<TenderProcedures />} />

        {/* Accounts */}
        <Route path="/accounts">
          <Route path="list" element={<Accounts />} />
          <Route path="add-account" element={<AddAccount />} />
          <Route path=":accountId" element={<DetailsAccount />} />
          
          {/* Projects */}
          <Route path=":accountId/projects">
            <Route path="add-project" element={<ProjectAddWrapper />} />
            <Route path=":projectId" element={<DetailsProject />} />

            {/* Activities */}
            <Route path=":projectId/activities">
              <Route path="add-activity" element={<ActivityAdd />} />
              <Route path=":activityId" element={<DetailsActivity />} />

              {/* Procedures */}
              <Route path=":activityId/procedures">
                <Route path="add-procedure" element={<ProcedureAdd />} />
                <Route path=":procedureId" element={<DetailsProcedure />} />

                {/* Stages */}
                <Route path=":procedureId/stages/">
                  <Route path="answers/:stageId" element={<StageAnswers />} />
                  <Route path="awardReport/:stageId" element={<StageAwardReports />} />
                  <Route path="complaints/:stageId" element={<StageComplaints />} />
                  <Route path="preliminaryReport/:stageId" element={<StagePreliminaryReports />} />
                  <Route path="proposals/:stageId" element={<StageProposals />} />
                  <Route path="questions/:stageId" element={<StageQuestions />} />
                  <Route path="report/:stageId" element={<StageReport />} />
                  <Route path="terms/:stageId" element={<StageTerms />} />
                </Route>

              </Route>
            </Route>
          </Route>
        </Route>

      </Route>
      <Route element={<PublicRoutes />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/licenses" element={<LicensesPage />} />
      </Route>
    </Routes>
  );
};

export default Router;
